import { styled } from '@mui/material';

export const Title = styled('h5')(() => ({
  marginBottom: 'var(--spacing-tiny)',
  minHeight: 'calc(var(--preference-compose-dropdown-width-desktop) / 3)',
  padding: 'var(--spacing-large) var(--spacing-medium)',
  textAlign: 'center',
}));
